import ReactMarkdown from 'react-markdown';

interface MarkdownProps {
  content: string;
  className?: string;
  size?: 'sm' | 'xs';
}

export function Markdown({ content, className, size = 'sm' }: MarkdownProps) {
  const xs = size === 'xs';
  return (
    <div className={className}>
      <ReactMarkdown
        components={{
          p: ({ children }) => (
            <p
              className={`${xs ? 'text-xs text-gray-500' : 'text-sm text-gray-700'} mb-2 last:mb-0`}
            >
              {children}
            </p>
          ),
          h1: ({ children }) => (
            <h1
              className={`${xs ? 'text-xs text-gray-500' : 'text-base text-gray-900'} font-bold mb-2 mt-3 first:mt-0`}
            >
              {children}
            </h1>
          ),
          h2: ({ children }) => (
            <h2
              className={`${xs ? 'text-xs text-gray-500' : 'text-sm text-gray-900'} font-bold mb-1.5 mt-3 first:mt-0`}
            >
              {children}
            </h2>
          ),
          h3: ({ children }) => (
            <h3
              className={`${xs ? 'text-xs text-gray-500' : 'text-sm text-gray-800'} font-semibold mb-1 mt-2 first:mt-0`}
            >
              {children}
            </h3>
          ),
          ul: ({ children }) => (
            <ul
              className={`list-disc list-outside pl-4 ${xs ? 'text-xs text-gray-500' : 'text-sm text-gray-700'} mb-2 space-y-0.5`}
            >
              {children}
            </ul>
          ),
          ol: ({ children }) => (
            <ol
              className={`list-decimal list-outside pl-4 ${xs ? 'text-xs text-gray-500' : 'text-sm text-gray-700'} mb-2 space-y-0.5`}
            >
              {children}
            </ol>
          ),
          li: ({ children }) => (
            <li className={`${xs ? 'text-xs text-gray-500' : 'text-sm text-gray-700'}`}>
              {children}
            </li>
          ),
          strong: ({ children }) => <strong className="font-semibold">{children}</strong>,
          em: ({ children }) => <em className="italic">{children}</em>,
          code: ({ children }) => (
            <code
              className={`bg-gray-100 rounded px-1 py-0.5 ${xs ? 'text-[10px]' : 'text-xs'} font-mono text-gray-800`}
            >
              {children}
            </code>
          ),
          a: ({ href, children }) => (
            <a
              href={href}
              className="text-blue-600 hover:underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              {children}
            </a>
          ),
          hr: () => <hr className="border-gray-200 my-3" />,
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
